import { Store } from 'src/store/index';

const getFrameUpsellFrameProductId = (store: Store) => store.upsell.frameUpsellPopupData?.items[store.upsell.frameUpsellSelectedFrame || 0]?.productId;
export default getFrameUpsellFrameProductId;
